<template>
  <div id="dashboard">
    <main-layout>
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab
          v-if="selectedBot.theme == 'sahapan'"
          ripple
          :key="'stat-customer'"
          :href="'#stat-customer'"
          >{{ $t('Customer Analytic') }}</v-tab
        >
        <v-tab v-if="isBU" ripple :key="'customers'" :href="'#customers'">
          {{ $t('Customer') }}
        </v-tab>
        <template
          v-if="
            selectedBot.theme != 'universalutilities' ||
            (selectedBot.theme == 'universalutilities' && $store.state.userid == 'uuadmin')
          "
        >
          <v-tab ripple :key="'stat-summary'" :href="'#stat-summary'">{{ $t('Dashboard') }}</v-tab>
          <v-tab ripple :key="'active-user-graph'" :href="'#active-user-graph'">{{
            $t('Metrics')
          }}</v-tab>
          <v-tab ripple :key="'summary-intent'" :href="'#summary-intent'">{{
            $t('Conversation')
          }}</v-tab>
        </template>

        <template v-if="['2428337527228612', '106728661059512'].includes(selectedBot.pageid)">
          <v-tab ripple :key="'neo-money-user-summary'" :href="'#neo-money-user-summary'">{{
            $t('User Summary')
          }}</v-tab>
        </template>

        <v-tab
          v-if="isRussianRoulette"
          ripple
          :key="'RussianRouletteDashboard'"
          :href="'#RussianRouletteDashboard'"
          >{{ $t('Admin performance') }}</v-tab
        >
        <v-tab
          v-if="!isBU && !['kasikorncareer', 'sahapan'].includes(selectedBot.theme)"
          ripple
          :key="'customers'"
          :href="'#customers'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="['sahapan'].includes(selectedBot.theme)"
          ripple
          :key="'SahapanCustomers'"
          :href="'#SahapanCustomers'"
          >{{ $t('Customer') }}</v-tab
        >
        <v-tab
          v-if="['ramapoisoncenter'].includes(selectedBot.theme)"
          ripple
          :key="'RamapoisonCustomers'"
          :href="'#RamapoisonCustomers'"
          >{{ $t('Customer') }}</v-tab
        >
        <template v-if="selectedBot.theme == 'kasikorncareer'">
          <v-tab ripple :key="'customers'" :href="'#customers'">{{ $t('Career Matching') }}</v-tab>
          <v-tab ripple :key="'kasikorn-personality-test'" :href="'#kasikorn-personality-test'">{{
            $t('Personality Test')
          }}</v-tab>
          <v-tab ripple :key="'kasikorn-digital-skill'" :href="'#kasikorn-digital-skill'">{{
            $t('Digital Skill')
          }}</v-tab>
        </template>
        <v-tab
          ripple
          v-if="selectedBot.theme == 'generali'"
          :key="'tag-report'"
          :href="'#tag-report'"
          >{{ $t('Tag') }}</v-tab
        >
        <v-tab ripple :key="'employee'" :href="'#employee'" v-if="selectedBot.theme == 'hafele'">{{
          $t('Employee')
        }}</v-tab>
        <v-tab
          ripple
          :key="'SahapanTopLocation'"
          :href="'#SahapanTopLocation'"
          v-if="selectedBot.theme == 'sahapan'"
          >{{ $t('Top Location') }}</v-tab
        >
        <!-- <v-tab
          ripple
          :key="'SahapanSalesreport'"
          :href="'#SahapanSalesreport'"
          v-if="selectedBot.theme == 'sahapan'"
        >
          {{
          $t('Sales Report')
          }}
        </v-tab>-->
        <v-tab
          ripple
          :key="'SahapanTopRewardPoint'"
          :href="'#SahapanTopRewardPoint'"
          v-if="selectedBot.theme == 'sahapan'"
          >{{ $t('Top Reward') }}</v-tab
        >

        <v-tab v-if="isBU" ripple :key="'inbox-stat-register'" :href="'#inbox-stat-register'">{{
          $t('Register')
        }}</v-tab>
        <v-tab v-if="isBU" ripple :key="'inbox-stat-faculty'" :href="'#inbox-stat-faculty'">{{
          $t('Faculty')
        }}</v-tab>
        <v-tab
          v-if="isBU"
          ripple
          :key="'inbox-stat-scholarships'"
          :href="'#inbox-stat-scholarships'"
          >{{ $t('Scholarships') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard'"
          :href="'#aston-dashboard'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Aston') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-line-dashboard'"
          :href="'#aston-line-dashboard'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('AstonLine') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-outsource-dashboard'"
          :href="'#aston-outsource-dashboard'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Outsource') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard-admin-message'"
          :href="'#aston-dashboard-admin-message'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Admin message') }}</v-tab
        >
        <v-tab
          ripple
          :key="'AstonConversationRate'"
          :href="'#AstonConversationRate'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Conversation Rate') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard-admin-timing'"
          :href="'#aston-dashboard-admin-timing'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('AdminTiming') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard-feedback'"
          :href="'#aston-dashboard-feedback'"
          v-if="astonpages.includes(selectedBot.pageid) && $store.getters.getPackage == 'premium'"
          >{{ $t('Feedback') }}</v-tab
        >
        <v-tab
          ripple
          :key="'ceemeagain'"
          :href="'#ceemeagain'"
          v-if="
            ['ceemeagain'].includes(selectedBot.theme) && $store.getters.getPackage == 'premium'
          "
          >{{ $t('Ceemeagain') }}</v-tab
        >
        <v-tab
          ripple
          :key="'superten-dashboard'"
          :href="'#superten-dashboard'"
          v-if="$store.state.supertenpage.includes(selectedBot.pageid)"
          >{{ $t('Vote') }}</v-tab
        >
      </v-tabs>
      <template v-if="currentView == 'customers'">
        <template v-if="selectedBot.theme == 'universalutilities'">
          <component :is="'uu-customers'"></component>
        </template>
        <template v-else-if="selectedBot.theme == 'kasikorncareer'">
          <component :is="'kasikorn-career'"></component>
        </template>
        <template v-else-if="['toa'].includes(selectedBot.theme)">
          <component :is="'ToaCustomer'"></component>
        </template>
        <template v-else>
          <component :is="currentView"></component>
        </template>
      </template>
      <template v-else-if="currentView == 'employee'">
        <component :is="'hafele-customers'"></component>
      </template>
      <template v-else>
        <!-- {{ currentView }} -->
        <component :is="currentView"></component>
      </template>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import numeral from 'numeral'
import $ from 'jquery'

import SahapanCustomers from './SahapanCustomers'
import KasikornCareer from './KasikornCareer'
import UuCustomers from './UuCustomers'
import HafeleCustomers from './HafeleCustomers'
import ToaCustomer from './ToaCustomer.vue'

import KasikornPersonalityTest from './KasikornPersonalityTest'
import KasikornDigitalSkill from './KasikornDigitalSkill'
// import StatSummary from '@/components/elements/MaintenancePage'
// import ActiveUserGraph from '@/components/elements/MaintenancePage'
// import SummaryIntent from '@/components/elements/MaintenancePage'
// import Customers from '@/components/elements/MaintenancePage'
// const StatSummary = () => import('./StatSummary.vue')
// const ActiveUserGraph = () => import('./ActiveUserGraph.vue')
// const Customers = () => import('./Customers.vue')
// const SummaryIntent = () => import('./SummaryIntent.vue')

// const InboxStatRegister = () => import('./InboxStatRegister.vue')
// const InboxStatFaculty = () => import('./InboxStatFaculty.vue')
// const InboxStatScholarships = () => import('./InboxStatScholarships.vue')

// const AstonDashboard = () => import('./AstonDashboard.vue')
// const AstonLineDashboard = () => import('./AstonLineDashboard.vue')
// const AstonOutsourceDashboard = () => import('./AstonOutsourceDashboard.vue')
// const AstonDashboardAdminMessage = () => import('./AstonDashboardAdminMessage.vue')
// const AstonDashboardAdminTiming = () => import('./AstonDashboardAdminTiming.vue')
// const AstonDashboardFeedback = () => import('./AstonDashboardFeedback.vue')
// const RussianRouletteDashboard = () => import('./RussianRouletteDashboard.vue')
// const AstonConversationRate = () => import('./AstonConversationRate.vue')

// const NeoMoneyUserSummary = () => import('./NeoMoneyUserSummary.vue')

// const BranchLocation = () => import('./BranchLocation.vue')

// const SupertenDashboard = () => import('./SupertenDashboard.vue')
import RamapoisonCustomers from './RamapoisonCustomers.vue'
import Ceemeagain from './Ceemeagain.vue'

import TagReport from './TagReport.vue'
import SahapanTopLocation from './SahapanTopLocation.vue'
import SahapanTopRewardPoint from './SahapanTopRewardPoint.vue'
import StatCustomer from './StatCustomer.vue'
import StatSummary from './StatSummary.vue'
import ActiveUserGraph from './ActiveUserGraph.vue'
import Customers from './Customers.vue'
import SummaryIntent from './SummaryIntent.vue'
import InboxStatRegister from './InboxStatRegister.vue'
import InboxStatFaculty from './InboxStatFaculty.vue'
import InboxStatScholarships from './InboxStatScholarships.vue'
import AstonDashboard from './AstonDashboard.vue'
import AstonLineDashboard from './AstonLineDashboard.vue'
import AstonOutsourceDashboard from './AstonOutsourceDashboard.vue'
import AstonDashboardAdminMessage from './AstonDashboardAdminMessage.vue'
import AstonDashboardAdminTiming from './AstonDashboardAdminTiming.vue'
import AstonDashboardFeedback from './AstonDashboardFeedback.vue'
import RussianRouletteDashboard from './RussianRouletteDashboard.vue'
import AstonConversationRate from './AstonConversationRate.vue'
import NeoMoneyUserSummary from './NeoMoneyUserSummary.vue'
import BranchLocation from './BranchLocation.vue'
import SupertenDashboard from './SupertenDashboard.vue'
export default {
  data: function () {
    return {
      showIntent: false,
      currentView: 'stat-summary',
    }
  },
  components: {
    StatSummary,
    ToaCustomer,
    AstonDashboard,
    AstonLineDashboard,
    ActiveUserGraph,
    SummaryIntent,
    Customers,
    UuCustomers,
    KasikornCareer,
    HafeleCustomers,
    TagReport,
    InboxStatRegister,
    InboxStatFaculty,
    AstonOutsourceDashboard,
    InboxStatScholarships,
    KasikornPersonalityTest,
    KasikornDigitalSkill,
    StatCustomer,
    AstonDashboardAdminMessage,
    AstonDashboardAdminTiming,
    AstonDashboardFeedback,
    SahapanTopLocation,
    SahapanTopRewardPoint,
    RussianRouletteDashboard,
    SahapanCustomers,
    NeoMoneyUserSummary,
    AstonConversationRate,
    RamapoisonCustomers,
    Ceemeagain,
    BranchLocation,
    SupertenDashboard
  },
  created: function () {
    let vm = this
    if (vm.$route.query.tab) {
      // switch (vm.$route.query.tab) {
      //   case 'statistic':
      //   case 'crm':
      //   case 'custom_analytic':
      //     vm.currentView = vm.$route.query.tab
      //     break
      //   default:
      //     vm.currentView = 'statistic'
      //     break
      // }
      vm.currentView = vm.$route.query.tab
    } else {
      if (this.selectedBot.theme == 'universalutilities' && this.$store.state.userid != 'uuadmin') {
        vm.currentView = 'customers'
      } else {
        vm.currentView = 'stat-summary'
      }
    }
  },
  mounted: function () {},
  computed: {
    astonpages() {
      return this.$aston.astonpages
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    isRussianRoulette() {
      return this.$store.state.pageRussianRoulette.includes(this.selectedBot.pageid)
    },
  },
  methods: {
    numberFormat: function (val) {
      return numeral(val).format('0,0')
    },
    updateRoute: function () {
      this.$router.push({
        name: 'dashboard',
        path: '/dashboard',
        query: {
          tab: this.currentView,
        },
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Dashboard.vue